import { render, staticRenderFns } from "./TimeoffHead.vue?vue&type=template&id=28dd2b2d&lang=html&"
import script from "./TimeoffHead.vue?vue&type=script&lang=js&"
export * from "./TimeoffHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports